import {
    FETCH_SUBSCRIPTION_LIST,
    FETCH_SUBSCRIPTION_LIST_SUCCESS,
    FETCH_SUBSCRIPTION_LIST_FAILED
  } from "../store/types";
  
  const INITIAL_STATE = {
    subscriptionsList:null,
    loading: false,
    error: {
      flag: false,
      msg: null
    }
  }
  
  export const subscriptionlistreducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
      case FETCH_SUBSCRIPTION_LIST:
        return {
          ...state,
          loading: true
        };
      case FETCH_SUBSCRIPTION_LIST_SUCCESS:
        return {
          ...state,
          subscriptionsList: action.payload,
          loading: false
        };
      case FETCH_SUBSCRIPTION_LIST_FAILED:
        return {
          ...state,
          subscriptionsList: null,
          loading: false,
          error: {
            flag: true,
            msg: action.payload
          }
        };
      default:
        return state;
    }
  };